import React from 'react';
import { Link } from 'react-router-dom';
import SubscriptionChip from '@components/navigation/subject/SubscriptionChip';
import { Button } from 'geniebook-ui/dist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { useSetAtom, useAtomValue } from 'jotai';
import { showUnlockTrialPopUpAtom } from '@atom/popUpAtom';
import globalStore from '@store/globalStore';
import { haveSubjectForTrialAtom } from '@atom/globalQueryAtom';

export interface SubjectDropdownItem {
  key: string;
  subjectId: number;
  label: string;
  url: string;
  expired: boolean;
  trial: boolean;
  order: number;
}

export interface SubjectDropdownProps {
  list: SubjectDropdownItem[];
  onClickItem: (key: string) => void;
  closeDropdown: () => void;
}

const SubjectDropdown = (props: SubjectDropdownProps) => {
  const haveSubjectForTrial = useAtomValue(haveSubjectForTrialAtom);
  const blacklistedSubjectbyId = [
    '49', // Summer Carnival
    '50', // Deposit Only
  ];
  const setUnlockTrialPopUp = useSetAtom(showUnlockTrialPopUpAtom, {
    store: globalStore,
  });

  function handleClick(event: React.FormEvent, key: string) {
    event.stopPropagation();
    props.onClickItem(key);
  }

  return (
    <div className="subject-dropdown-container backdrop-blur-sm bg-neutral-chalk/[0.92] rounded-2xl shadow-[0_3px_15px_0_#27AAE166] py-4 pr-1 overflow-hidden">
      <div className="subject-dropdown-scrollable scrollbar-light px-6 max-h-[calc(100vh-100px)] max-lg:max-h-[calc(100vh-187px)] -my-4 py-4">
        {props.list.map(item => {
          // list of blacklisted subject
          if (
            item.label === 'GeniePod' ||
            blacklistedSubjectbyId.includes(item.subjectId.toString())
          ) {
            return null;
          }
          return (
            <div
              key={item.key}
              onClick={event => handleClick(event, item.key)}
              className={'pb-4 w-max last:pb-0 font-bold text-primary-navyblue'}
              data-testid={'subject-item-' + item.key}
            >
              <Link to={item.url} className="flex items-center">
                {item.label}
                {item.expired || item.trial ? (
                  <SubscriptionChip type={item.expired ? 'Expired' : 'Trial'} />
                ) : null}
              </Link>
            </div>
          );
        })}
        {haveSubjectForTrial && (
          <div>
            <Button
              variant={'primary-azure'}
              className={
                'text-white !font-black !text-sm mb-2 px-4 !h-9 !max-w-full !w-full whitespace-nowrap'
              }
              onClick={() => setUnlockTrialPopUp(true)}
            >
              <FontAwesomeIcon
                icon={faLock}
                className={'text-white w-[18px] h-4'}
              />
              &nbsp; Unlock new subjects
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

SubjectDropdown.defaultProps = {
  onClickItem: () => {},
};

export default SubjectDropdown;
